import React from 'react';
import { BotaoCustomizado } from './styles';

const Botao = ({
  type,
  text,
  onClick,
  disabled,
  loading = false,
}) => { 
  return (
    <BotaoCustomizado
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Por favor, aguarde...
        </>
      ) : (
        text
      )}
    </BotaoCustomizado>
  );
};

export default Botao;
